import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { ConfirmationHelperService } from '../services/confirmation-helper.service';
import type { CesCampaignDetailsComponent } from '../components/pages/assets/configuration/campaigns/campaign-details.component';

const MESSAGE_KEY = 'entities.campaign.messages.confirmDiscard';
const TITLE_KEY = 'entities.automaticPost.messages.editMode.unsavedTitle';

// Campaign tabs save per-tab, so there is no unified save to offer here: a clean leave is
// allowed, a dirty one asks to discard. Caution variant (triangle) — data loss, not a benign notice.
export const campaignEditDirtyGuard: CanDeactivateFn<CesCampaignDetailsComponent> = component => {
  if (!component.hasUnsavedChanges()) return true;
  const confirm = inject(ConfirmationHelperService);
  return confirm.ask(MESSAGE_KEY, TITLE_KEY, undefined, 'pi pi-exclamation-triangle', 'common.buttons.discard');
};
